import Vue from 'vue'
import VueResource from 'vue-resource'

import { DataArrayTransformer } from '@/helpers/orders/data-array.transformer.js'
import { DataTransformer } from '@/helpers/orders/data.transformer.js'
Vue.use(VueResource)

import { ApiUtil as api } from "@/utils/api.util.js";

export class OrderService {
  static URL = process.env.API_URL + process.env.API_VER

  static all(queryParams = {}) {

    // console.log(queryParams);

    return Vue.http.get(this.URL + '/orders', { params: queryParams }).then(
      response => {
        return response.data
        // return DataArrayTransformer.transform(response.data);
      },
      error => {
        console.error(error)
      }
    )
  }

  // Temporary name
  static unpaginated(queryParams = {}) {
    return Vue.http.get(this.URL + '/orders/all', { params: queryParams }).then(
      response => {
        return response.data
        // return DataArrayTransformer.transform(response.data);
      },
      error => {
        console.error(error)
      }
    )
  }

  static findOrderById (id, queryParams = {}, config = {}) {
    return api.get(this.URL + '/orders/' + id, queryParams, config)
  }

  static findClaimIds() {
    return Vue.http.get(this.URL + '/claimIds').then(
      response => {
        let filtered = []
        /* filtered.push({
                    value: "all",
                    text: "ALL"
                }); */
        response.data.data.map(function (item) {
          let claim = {}
          claim.value = item.claimId
          claim.text = item.claimId
          filtered.push(claim)
        })

        return filtered
      },
      error => {
        console.error(error)
      }
    )
  }

  static findRegions() {
    return Vue.http.get(this.URL + '/orders?get_planner_groups').then(
      response => {
        return response.data
      },
      error => {
        console.error(error)
      }
    )
  }

  static listStatusGroup() {
    return new Promise(resolve => {
      resolve([
        {
          text: 'Open',
          value: [
            'APPROVED',
            'STARTED',
            'PHYSICALLY_COMPLETED',
            'PROGRAMMED',
            'WAITAPPROVAL',
            'IN_DISPUTE'
          ]
        },
        {
          text: 'Closed',
          value: [
            'COMPLETED',
            'FINALISED_NOBILLING',
            'BLAP',
            'BLRQ',
            'BILLING_COMPLETE'
          ]
        },
        {
          text: 'Void',
          value: ['CLOSED_D', 'CLOSED_N', 'REJECTED', 'INCC_ASSIGNED']
        }
      ])
    })
  }

  static findByCode(code) {
    return Vue.http.get(this.URL + '/codes?type=' + code).then(
      response => {
        return response.data
      },
      error => {
        console.error(error)
      }
    )
  }

  static listOrderTypes() {
    return Vue.http.get(this.URL + '/orders/order-types').then(
      response => {
        return response.data
      },
      error => {
        console.error(error)
      }
    )
  }

  static listPriorities() {
    return Vue.http.get(this.URL + '/orders/priorities').then(
      response => {
        return response.data
      },
      error => {
        console.error(error)
      }
    )
  }

  static create(data) {
    return api.post(this.URL + '/orders', data)
    return Vue.http.post(this.URL + '/orders', data)
  }
  static basicCreate(data) {
    return Vue.http.post(this.URL + '/orders/basic', data)
  }
  static update(id, data) {
    return api.put(this.URL + '/orders/' + id, data)
    return Vue.http.put(this.URL + '/orders/' + id, data)
  }

  static updatePartial(id, data) {
    return Vue.http.put(this.URL + '/orders/' + id + '/partial', data)
  }

  static closeDuplicate(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/closed-duplicate`, data)
  }

  static start(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/start`, data)
  }

  static madeSafe(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/made-safe`, data)
  }

  static finish(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/physically-complete`, data)
  }

  static complete(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/complete`, data)
  }

  static claim(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/blrq`, data)
  }

  static approveBilling(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/blap`, data)
  }

  static rejectBilling(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/in-dispute`, data)
  }

  static bulkComplete(data) {
    return Vue.http.put(this.URL + '/orders/complete', data)
  }

  static bulkClaim(data) {
    return Vue.http.put(this.URL + '/orders/blrq', data)
  }

  static bulkApproveBilling(data) {
    return Vue.http.put(this.URL + '/orders/blap', data)
  }

  static bulkRejectBilling(data) {
    return Vue.http.put(this.URL + '/orders/in-dispute', data)
  }

  static bulkCancel(data) {
    return Vue.http.put(this.URL + '/orders/cancel', data)
  }

  static incorrectlyAssign(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/incorrectly-assigned`, data)
  }

  static print(id, data = {}) {
    return api.post(this.URL + `/orders/${id}/print`, data, { responseType: 'blob' })
  }

  static printPreview(id, data = {}) {
    return api.post(this.URL + `/orders/${id}/print`, { ...data, preview: 1 }, {
      responseType: 'text'
    })
  }

  static appealKpiResult(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/appeal-kpi-result`, data)
  }

  static reverseKpiResult(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/reverse-kpi-result`, data)
  }

  static approveKpiResult(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/approve-kpi-result`, data)
  }

  static rejectKpiResult(id, data) {
    return Vue.http.put(this.URL + `/orders/${id}/reject-kpi-result`, data)
  }

  static listHierarchy(id) {
    return Vue.http.get(this.URL + `/orders/${id}/hierarchy`)
  }

  static exportOrders(queryParams = {}) {
    return Vue.http.get(this.URL + `/orders/export`, { params: queryParams })
  }

  static paymentTiming(order_id) {
    return Vue.http.get(this.URL + `/orders/${order_id}/payment-timing`).then(
      response => {
        return response.data;
      },
      error => {
        console.error(error);
      }
    );
  }

  static listLinkedOrders(id) {
    return Vue.http.get(this.URL + `/orders/${id}/linked-orders`)
  }

  static link(id, orderId) {
    return Vue.http.post(this.URL + `/orders/${id}/linked-orders/link`, { orderId })
  }

  static assignParent(id, orderId) {
    return Vue.http.post(this.URL + `/orders/${id}/assign-parent`, { orderId })
  }

  static requestDateChange(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/request-date-change`, data)
  }

  static approveDateChange(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/approve-date-change`, data)
  }

  static rejectDateChange(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/reject-date-change`, data)
  }

  static withdrawDateChange(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/withdraw-date-change`, data)
  }

  static propose(id, data = {}) {
    return api.put(this.URL + `/orders/${id}/propose`, data)
  }

  static approve(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/approve`, data)
  }

  static reject(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/reject`, data)
  }

  static listComments(id, queryParams = {}) {
    return Vue.http.get(this.URL + `/orders/${id}/comments`, { params: queryParams })
  }

  static createComment(id, data = {}) {
    return Vue.http.post(this.URL + `/orders/${id}/comments`, data)
  }

  static vetComment(order_id, comment_id, data = {}) {
    return Vue.http.post(this.URL + `/orders/${order_id}/comments/${comment_id}/vet`, data)
  }

  static calculateSla(queryParams = {}) {
    return Vue.http.get(this.URL + '/orders/calculate-sla', { params: queryParams })
  }
  static updateAssignedTo(id, data = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/assigned-to`, data)
  }

  static listLogs(id, queryParams = {}) {
    return Vue.http.get(this.URL + `/orders/${id}/logs`, { params: queryParams })
  }

  static getAklcIntegrationLink(id) {
    return Vue.http.get(this.URL + `/orders/${id}/aklc-integration-link`);
  }

  static getState(id) {
    return Vue.http.get(this.URL + `/orders/${id}/state`);
  }

  static lock(id) {
    return Vue.http.post(this.URL + `/orders/${id}/lock`);
  }

  static unlock(id) {
    return Vue.http.post(this.URL + `/orders/${id}/unlock`);
  }

  static listNotifications(id, queryParams = {}) {
    return Vue.http.get(this.URL + `/orders/${id}/notifications`, { params: queryParams })
  }

  static addAttribute(id,data = {}) {
    return api.post(this.URL + `/orders/${id}/attribute`,data);
  }

  static removeAttribute(id,queryParams = {}) {
    return Vue.http.delete(this.URL + `/orders/${id}/attribute`, { params: queryParams });
  }

  static star(id, queryParams = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/star`, { params: queryParams });
  }

  static unstar(id, queryParams = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/unstar`, { params: queryParams });
  }

  static rate(id, queryParams = {}) {
    return api.put(this.URL + `/orders/${id}/rate`, queryParams);
  }

  static requestLateClaim(id, queryParams = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/request-late-claim`, { params: queryParams });
  }

  static unrequestLateClaim(id, queryParams = {}) {
    return Vue.http.put(this.URL + `/orders/${id}/unrequest-late-claim`, { params: queryParams });
  }

  static getOrder(queryParams = {}) {
    return Vue.http.get(this.URL + `/get-orders/`, { params: queryParams });
  }

  static listBillingCodes() {
    return Vue.http.get(this.URL + '/orders/billing-codes').then(
      response => {
        return response.data
      },
      error => {
        console.error(error)
      }
    )
  }

  static updateBillingCodes(queryParams = {}) {
    return Vue.http.put(this.URL + "/orders/billing-codes", queryParams);
  }

  static cancel(id) {
    return Vue.http.put(this.URL + "/orders/" + id + "/cancel");
  }

  static filters(queryParams = {}) {
    return Vue.http.get(this.URL + "/orders/filters", { params: queryParams });
  }
}



// WEBPACK FOOTER //
// ./src/services/order.service.js